import { Box, Container } from "@mui/material";
import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { createApiCall } from "../../api/api-service";
import CommonLabel from "../../components/label";
import CommonFilterBox from "../../components/filter-box";
import ProductGrid from "../../components/product-grid";
import CommonPagination from "../../components/pagination/common-pagination";
import CategorySection from "../../components/category-section/category-section";

const SearchPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState(1);

  const filterSections = [
    {
      key: "price",
      header: "Price",
      values: [" ₹ 10 - 399", "₹ 400 - 699", "₹ 700 - 999", "Above ₹999"],
      type: "radio",
    },
    {
      key: "coo",
      header: "Country Of Origin",
      values: ["India", "China", "Germeny", "USA", "Korea"],
      type: "radio",
    },
    {
      key: "availability",
      header: "Availability",
      values: ["In Stock", "Out of Stock"],
      type: "radio",
    },
  ];;

  const filterValues = useMemo(
    () => Object.fromEntries([...searchParams]),
    [searchParams],
  );
  const searchParamsString = searchParams.toString();

  const fetchSearchProduct = async (page = 1) => {
    const payload = {
      query: searchParams.get("query"),
      page,
      page_size: 20,
      ...filterValues,
    };
    const data = await createApiCall(
      "POST",
      "inventory/fetch_search_product",
      payload, true
    );
    return data || {};
  };

  const { data: searchedProduct = {} } = useQuery({
    queryKey: ["search", searchParamsString, currentPage],
    queryFn: () => fetchSearchProduct(currentPage),
    staleTime: 5 * 60 * 1000,
    retry: 1,
    placeholderData: (previousData) => previousData,
  });
  const products = searchedProduct?.data || [];
  const productCount = searchedProduct?.pagination || {};
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  console.log(products)
  return (
    <Container sx={{ py: 2 }}>
      {/*<Box
    //     sx={{
    //       display: "flex",
    //       flexDirection: { xs: "column", md: "row" },
    //       justifyContent: "space-between",
    //       alignItems: "center",
    //     }}
    //   >
    //     <CommonLabel variant={"h5"}>Search {searchParams.get("query")}</CommonLabel>
    //     {/* <Box>
    //       <CommonTextBox placeholder={"Search Product ..."} />
    //     </Box> 
    //   </Box>

      {/* <CategorySection category={categoryList} /> */}

      <Box sx={{ display: "flex", marginTop: "10px", gap: 7 }}>
        <Box
          sx={{
            display: { xs: "none", sm: "none", md: "block", lg: "block" },
            width: "20%",
          }}
        >
          <CommonFilterBox
            title="Filters"
            sections={filterSections}
            onFilterChange={(e) => {
              setCurrentPage(1);
              const currentParams = Object.fromEntries([...searchParams]);
              const nextParams = Object.entries({
                ...currentParams,
                ...e,
              }).reduce((acc, [key, value]) => {
                acc[key] = Array.isArray(value) ? value.join(",") : value;
                return acc;
              }, {});
              setSearchParams(nextParams);
            }}
          />
        </Box>
        <Box
          sx={{
            display: { md: "block", lg: "block" },
            width: { xs: '100%', ms: "80%" },
          }}
        >
          <CommonPagination
            page={productCount?.page || 1}
            totalPages={productCount?.total_pages || 1}
            pageSize={productCount?.page_size || 20}
            totalCount={productCount?.total_count || 0}
            onPageChange={handlePageChange}
            showResultCount={true}
          />
          <Box sx={{ mb: "10px" }}>
            <ProductGrid productList={products} />
          </Box>
        </Box>
      </Box>
      {/* Horizontal Scrollable Categories */}
      {/* <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          maxWidth: '100%',
          overflowX: 'auto',
          alignItems: 'center',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' } // Hide scrollbar on WebKit
        }}
      >
        {categoryList.map((value, index) => (
          <Circle
            key={index}
            categoryUrl={`/category/${value?.category_name}`}
            content={value?.category_image}
            text={value?.category_name}
            highlight = {category === value?.category_name}
          />
        ))}
      </Box>

      {/* Header Row */}
      {/* <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 2, mb: 1 }}>
        <Typography variant="h6">{category.toLocaleUpperCase()}</Typography>
        <Typography variant="body2" color="text.secondary">{productsLength} Products</Typography>
      </Box> */}

      {/* Product Grid */}
      {/* <Grid container spacing={2}>
        {products.map((item, index) => {
          
          return (
            <Grid item key={index} xs={12} sm={6} md={4} lg={3}>
              <ProductCard
                cardUrl={item?.variant_url}
                cardText={item?.variant_name}
                cardImage={item?.variant_image}
              />
            </Grid>
          );
        })}
      </Grid> */}
    </Container>
  );
};

export default SearchPage;
